import { ExpenseFilter } from "@/types/filter";

export const chartHelper = (daysCount: number, expenses: ExpenseFilter[]) => {
  const today = new Date();
  const expenseMap = new Map<string, number>();

  expenses.forEach((e) => {
    const dateStr = new Date(e.date).toISOString().split("T")[0];
    expenseMap.set(dateStr, (expenseMap.get(dateStr) || 0) + Number(e.amount));
  });

  const result: { date: string; amount: number }[] = [];

  for (let i = daysCount - 1; i >= 0; i--) {
    const date = new Date();
    date.setDate(today.getDate() - i);
    const dateStr = date.toISOString().split("T")[0];

    result.push({
      date: dateStr,
      amount: expenseMap.get(dateStr) ?? 0,
    });
  }

  return result;
};
